module.exports = __webpack_public_path__ + "static/img/siteminder.e8e58e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/合作夥伴/siteminder.png?20181011
// module id = fkgc
// module chunks = 1